import { Card, Stack, Alert } from '@mui/material'
import WildfireSummary from './wildfire/WildfireSummary'
import WildfireFWIDays from './wildfire/WildfireFWIDays'
import type { AdaptationView, CanonicalPeriod, EmissionTier } from '../common'

type PropertyWildfireProps = {
  propertyId: number
  emissionTier: EmissionTier
  selectedPeriod: CanonicalPeriod
  view?: AdaptationView
}

const PropertyWildfire = ({ propertyId, emissionTier, selectedPeriod, view }: PropertyWildfireProps) => {
  if (!propertyId) return <Alert severity="info">Select a property to view wildfire metrics.</Alert>

  return (
    <Stack spacing={4}>
      <Card sx={{ p: 3 }}>
        <WildfireSummary
          propertyId={propertyId}
          emissionTier={emissionTier}
          selectedPeriod={selectedPeriod}
          view={view}
        />
      </Card>
      <Card sx={{ p: 3 }}>
        <WildfireFWIDays propertyId={propertyId} emissionTier={emissionTier} view={view} />
      </Card>
    </Stack>
  )
}

export default PropertyWildfire
